import React, { useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link, useNavigate } from 'react-router-dom';

import { CompanyCreate } from '../../../schema/company';
import { api } from '../../../api';

const CreateCompany: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState<CompanyCreate>({
    company_code: '',
    company_name: '',
    company_name_en: '',
    company_type_id: '',
    company_id: '',
    phone_number: '',
    email: '',
    address: ''
  });
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    api.post<CompanyCreate>(`/company`, form).then(() => {
      navigate('/company-management');
    })
    .catch(() => {
      setOpenConfirmDialog(true);
    })
  };
  const handleOnChangeNoSpace = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regexDigit = event.target.value.match(/[\dA-Za-z]+/g);
    const digitStr = regexDigit ? regexDigit.join('') : '';
    setForm({ ...form, [event.target.name]: digitStr });
  };

  const handleOnChangeOnlyNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regexDigit = event.target.value.match(/\d+/g);
    const digitStr = regexDigit ? regexDigit.join('') : '';
    setForm({ ...form, [event.target.name]: digitStr });
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleOnSelectChange = (event: SelectChangeEvent) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  return (
    <RootContainer>
      <PageHeader text="เพิ่มข้อมูลบริษัท" />
      <Button component={Link} to="/company-management" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        จัดการข้อมูลบริษัท
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ p: 2 }}>
          เพิ่มข้อมูลบริษัท
        </Typography>
        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="ชื่อบริษัท"
                variant="outlined"
                placeholder="ชื่อบริษัท"
                name="company_name"
                value={form.company_name}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="ชื่อบริษัท (ภาษาอังกฤษ)"
                variant="outlined"
                placeholder="ชื่อบริษัท (ภาษาอังกฤษ)"
                name="company_name_en"
                value={form.company_name_en}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="รหัสบริษัท"
                variant="outlined"
                placeholder="รหัสบริษัท"
                name="company_code"
                value={form.company_code}
                onChange={handleOnChangeNoSpace}
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="หมายเลขผู้เสียภาษี"
                variant="outlined"
                placeholder="หมายเลขผู้เสียภาษี"
                name="company_id"
                value={form.company_id}
                onChange={handleOnChangeOnlyNumber}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="company-type">ประเภทบริษัท</InputLabel>
                <Select
                  required
                  labelId="company-type"
                  label="ประเภทบริษัท"
                  name="company_type_id"
                  variant="outlined"
                  onChange={handleOnSelectChange}
                  value={form.company_type_id}
                  autoComplete="off"
                >
                  <MenuItem value="2">ประจำ</MenuItem>
                  <MenuItem value="3">ชั่วคราว</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ที่อยู่"
                variant="outlined"
                placeholder="ที่อยู่"
                name="address"
                value={form.address}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เบอร์โทรศัพท์"
                variant="outlined"
                placeholder="เบอร์โทรศัพท์"
                name="phone_number"
                value={form.phone_number}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="อีเมล"
                variant="outlined"
                placeholder="อีเมล"
                name="email"
                value={form.email}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={6}>
              <Button
                component={Link}
                to="/company-management"
                type="button"
                variant="outlined"
                color="error"
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid container item xs={6} sx={{ justifyContent: 'end' }}>
              <Button type="submit" variant="contained" color="primary">
                สร้าง
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
          เกิดข้อผิดพลาด
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            หมายเลขผู้เสียภาษี หรือ รหัสบริษัท มีข้อมูลแล้วค่ะ
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 2 }}>
          <Button
            onClick={() => {
              setOpenConfirmDialog(false);
              setTimeout(() => {
                document.getElementById('personGPSDevice')?.focus();
              }, 300);
            }}
            color="primary"
            autoFocus
          >
            รับทราบ
          </Button>
        </DialogActions>
      </Dialog>
    </RootContainer>
  );
};

export default CreateCompany;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
